export const iconFontAwesomeArrowsShareFromSquare = (
	<i className="fa-solid fa-share-from-square"></i>
);
